<script setup>
import ServiceHistoryGrid from '@/components/garage/ServiceHistoryGrid.vue'
</script>
<template>
  <service-history-grid />
</template>
